import { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  TextField,
  FormControlLabel,
  Checkbox,
  Box,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import InfoIcon from '@mui/icons-material/Info';
import EditItemView from './components/EditItemView';
import EditAttributesAccordion from './components/EditAttributesAccordion';
import { useTranslation } from '../common/components/LocalizationProvider';
import useGeofenceAttributes from '../common/attributes/useGeofenceAttributes';
import SettingsMenu from './components/SettingsMenu';
import SelectField from '../common/components/SelectField';
import { geofencesActions } from '../store';
import useSettingsStyles from './common/useSettingsStyles';

const GeofencePage = () => {
  const { classes } = useSettingsStyles();
  const dispatch = useDispatch();
  const t = useTranslation();

  const geofenceAttributes = useGeofenceAttributes(t);

  const [item, setItem] = useState(null);

  const onItemSaved = (result) => {
    dispatch(geofencesActions.update([result]));
  };

  const validate = () => item && item.name && item.area;

  return (
    <EditItemView
      endpoint="geofences"
      item={item}
      setItem={setItem}
      validate={validate}
      onItemSaved={onItemSaved}
      menu={<SettingsMenu />}
      breadcrumbs={['settingsTitle', 'sharedGeofence']}
    >
      {item && (
        <>
          <Accordion defaultExpanded>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Box display="flex" alignItems="center" gap={1}>
                <NewReleasesIcon color="primary" />
                <Typography variant="subtitle1">{t('sharedRequired')}</Typography>
              </Box>
            </AccordionSummary>
            <AccordionDetails className={classes.details}>
              <Box
                display="flex"
                flexDirection="column"
                gap={2}
                width="100%"
              >
                <Box
                  display="flex"
                  width="100%"
                  gap={2}
                  sx={{ flexDirection: { xs: 'column', sm: 'row' } }}
                >
                  {/* Nome */}
                  <Box flex={1} minWidth={0}>
                    <TextField
                      fullWidth
                      value={item.name || ''}
                      onChange={(event) => setItem({ ...item, name: event.target.value })}
                      label={t('sharedName')}
                    />
                  </Box>

                  {/* Area (textarea) */}
                  {/* <Box flex={2} minWidth={0}>
                    <TextField
                      fullWidth
                      multiline
                      rows={4}
                      value={item.area || ''}
                      onChange={(event) => setItem({ ...item, area: event.target.value })}
                      label={t('sharedArea')}
                    />
                  </Box> */}
                </Box>
              </Box>
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Box display="flex" alignItems="center" gap={1}>
                <InfoIcon color="primary" />
                <Typography variant="subtitle1">
                  {t('sharedExtra')}
                </Typography>
              </Box>
            </AccordionSummary>
            <AccordionDetails className={classes.details}>
              <Box display="flex" flexDirection="column" gap={3}>
                {/* Linha 1 - Description e Calendar */}
                <Box display="flex" gap={2} sx={{ flexDirection: { xs: 'row', sm: 'row' }, flexWrap: 'wrap' }}>
                  <Box flex={1} minWidth={0}>
                    <TextField
                      fullWidth
                      value={item.description || ''}
                      onChange={(event) => setItem({ ...item, description: event.target.value })}
                      label={t('sharedDescription')}
                    />
                  </Box>
                  <Box flex={1} minWidth={0}>
                    <SelectField
                      fullWidth
                      value={item.calendarId}
                      onChange={(event) => setItem({ ...item, calendarId: Number(event.target.value) })}
                      endpoint="/api/calendars"
                      label={t('sharedCalendar')}
                    />
                  </Box>
                </Box>
                {/* Linha 2 - Checkbox */}
                <Box display="flex" flexDirection="column" gap={2}>
                  <Box display="flex" gap={2} sx={{ flexDirection: { xs: 'column', sm: 'row' } }}>
                    <Box flex={1} minWidth={0} display="flex" alignItems="center">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={item.attributes?.hide || false}
                            onChange={(e) =>
                              setItem({
                                ...item,
                                attributes: { ...item.attributes, hide: e.target.checked },
                              })
                            }
                          />
                        }
                        label={t('sharedFilterMap')}
                      />
                    </Box>
                    <Box flex={1} minWidth={0} />
                    <Box flex={1} minWidth={0} />
                  </Box>
                </Box>
              </Box>
            </AccordionDetails>
          </Accordion>

          <EditAttributesAccordion
            attributes={item.attributes}
            setAttributes={(attributes) => setItem({ ...item, attributes })}
            definitions={geofenceAttributes}
          />
        </>
      )}
    </EditItemView>
  );
};

export default GeofencePage;
